import { createActionTypes } from "@helpers/redux-helpers";

export const getListFAQCategoryActionTypes =
  createActionTypes("getFAQCategory");

export const getPortionListFAQCategoryActionTypes = createActionTypes(
  "getFAQCategory/portion",
);

export const getFAQItemByCategoryActionTypes = createActionTypes(
  "FAQItemByCategory/get",
);

export const getPortionFAQItemByCategoryActionTypes = createActionTypes(
  "FAQItemByCategory/getPortion",
);
